import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { InitialStatus } from '../timesheetPageSlice'
export interface KmsVehicle {
	kmsId?: number
	kmsIni: number
	kmsEnd?: number
	inEmpty: boolean
}
export interface ServiceExecutionUpdateRequest {
	serviceId?: number
	pax?: number
	isClean?: boolean
	startDateTime?: string
	endDateTime?: string
	kmsVehicles: KmsVehicle[]
	isAU?: boolean
}

export interface WorktimesRequest {
	timeSheetApprovalWorkTimesId?: number
	startTime: string
	endTime?: string
	isClean: boolean
}

export interface ApprovalRequest {
	timesheetId: number
	comments: string
	refund: number
	refunds: string | null
	workTypeId: number
	dispDrivingBreak: number | null
	uniqueAgent: string | null
	hasChangesFromReviewer: boolean
	extraTimePayment: boolean
	dispRecalculateOnSave: boolean
	initialStatus: InitialStatus
	benefits: number[]
	services: ServiceExecutionUpdateRequest[]
	workTimes: WorktimesRequest[]
}

export interface MassApprovalRequest {
	comments: string
	driverName: string
	status: 'SubmittedWithoutChanges'
	timeSheetId: number
	timesheetDate: string
	totalServices: number
}

export interface MassApprovalRequest {
	comments: string
	driverName: string
	status: 'SubmittedWithoutChanges'
	timeSheetId: number
	timesheetDate: string
	totalServices: number
}

export interface Reject {
  timesheetId: number;
  comments: string;
  title?: string;
  message?: string;
}

const initialStateReject: Reject = {
  timesheetId: 0,
  comments: '',
  title: '',
  message: '',
};

const initialStateApproval: ApprovalRequest = {
	timesheetId: 0,
	comments: '',
	refund: 0,
	workTypeId: 0,
	hasChangesFromReviewer: false,
	uniqueAgent: null,
	initialStatus: {
		kmsId: 0,
		kmsIni: 0,
		regDate: '2025-03-12T16:23:38.766Z',
		inEmpty: false,
		isClean: false,
	},
	services: [
		{
			serviceId: 0,
			pax: 0,
			isClean: true,
			startDateTime: '',
			endDateTime: '',
			kmsVehicles: [
				{
					kmsId: 0,
					kmsIni: 0,
					kmsEnd: 0,
					inEmpty: true,
				},
			],
		},
	],
	workTimes: [],
	benefits: [],
	refunds: null,
	extraTimePayment: false,
	dispRecalculateOnSave: true,
	dispDrivingBreak: null,
}

export const timesheetApprovalDetailsAcceptSlice = createSlice({
	name: 'timesheetApprovalDetailsAccept',
	initialState: initialStateApproval,
	reducers: {
		acceptApproval: (state, action: PayloadAction<Partial<ApprovalRequest>>) => {
			Object.assign(state, action.payload)
		},
		acceptApprovalInitialStatus: (state, action: PayloadAction<Partial<InitialStatus>>) => {
			Object.assign(state.initialStatus, action.payload)
		},
		acceptApprovalServices: (state, action: PayloadAction<Partial<ServiceExecutionUpdateRequest>[]>) => {
			Object.assign(state.services, action.payload)
		},
		acceptApprovalWorkTimes: (state, action: PayloadAction<Partial<WorktimesRequest>[]>) => {
			Object.assign(state.workTimes, action.payload)
		},
		acceptApprovalBenefits: (state, action: PayloadAction<number[]>) => {
			Object.assign(state.benefits, action.payload)
		},
	},
})

export const timesheetApprovalDetailsRejectSlice = createSlice({
	name: 'timesheetApprovalDetailsReject',
	initialState: initialStateReject,
	reducers: {
		rejectApproval: (state, action: PayloadAction<Partial<Reject>>) => {
			Object.assign(state, action.payload)
		},
	},
})

export const {
	acceptApproval,
	acceptApprovalInitialStatus,
	acceptApprovalServices,
	acceptApprovalWorkTimes,
	acceptApprovalBenefits,
} = timesheetApprovalDetailsAcceptSlice.actions
export const { rejectApproval } = timesheetApprovalDetailsRejectSlice.actions
